import { Button } from '@mm/components';
import {
  selectCurrentUserIsAdmin,
  selectSessionSelector,
} from '@mm/state/selectors/userSelector';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { IS_PROD_URL } from '@mm/utils';
import React from 'react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useBookDemo } from '../../../common/buttons/BookDemoButton/use-book-demo';
import { Logo } from '../../../layout/BotBuilderSidebar/Logo/Logo';
import {
  extractDomainName,
  ONBOARDING_UTM,
} from '../XRayOnboarding/WebsiteReportSummary/constants';
import { Routes } from '../../../routes/top-level-routes';
import styles from './BookCalendlyMeeting.module.css';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';

export const BookCalendlyMeeting = () => {
  const activeCompany = useSelector(activeCompanySelector);
  const session = useSelector(selectSessionSelector);
  const isSysOrCSAdmin = useSelector(selectCurrentUserIsAdmin);
  const { demoUrl } = useBookDemo(ONBOARDING_UTM);
  const { updateUserAttributes } = useUsersCRUDActions();
  const history = useHistory();

  const devAgencySqlUrl = `${'https://calendly.com/isupranovich-efe/agency-sql'}?${ONBOARDING_UTM}`;
  const devSqlUrl = `${'https://calendly.com/inha-zpy5/30min'}?${ONBOARDING_UTM}`;
  const devDiscoUrl = `${'https://calendly.com/ingasupranovich/non-sql'}?${ONBOARDING_UTM}`;

  const iframeTitle = 'calendly-onboarding';
  const domainName = extractDomainName(activeCompany?.website || '');
  const isSql = activeCompany?.consideredQualified;
  const calendlyURL = IS_PROD_URL
    ? demoUrl
    : activeCompany?.companyAttributes?.agency && isSql
    ? devAgencySqlUrl
    : isSql
    ? devSqlUrl
    : devDiscoUrl;

  const onSuccess = async () => {
    await updateUserAttributes(activeCompany?.id, session.id, {
      requestedDemo: true,
      onboardingSignupStep: OnboardingSignupStep.NONE,
    });
    history.push(Routes.chatbotEditor.path);
  };

  useCalendlyEventListener({
    onEventScheduled: () => setTimeout(onSuccess, 2000),
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.navbar}>
        {' '}
        <Logo className={styles.desktopLogo} />
      </div>
      <div className={styles.container}>
        <div className={styles.header}>
          <div>
            {domainName && <div className={styles.website}>{domainName}</div>}
            <div className={styles.heading}>
              Schedule a demo for setting up your account{' '}
              {(!isSql || isSysOrCSAdmin) && (
                <Button
                  color="secondary-blue"
                  css={{ container: styles.secondaryButton }}
                  onClick={() => onSuccess()}
                >
                  Skip This Step
                </Button>
              )}
            </div>
          </div>
        </div>

        <InlineWidget
          url={calendlyURL}
          styles={{ height: '100%' }}
          iframeTitle={iframeTitle}
          prefill={{
            name: `${session.firstName} ${session.lastName}`,
            firstName: session.firstName,
            lastName: session.lastName,
            email: session.email,
            customAnswers: {
              a1: activeCompany?.name,
              a2: activeCompany?.phoneNumber ?? '',
              a3: activeCompany?.website,
            },
          }}
        />
      </div>
    </div>
  );
};
